<div class="container-02" (sdxInView)="inView = true" [@staggerIn]="inView">
  <div *ngFor="let n of cueElement.children; trackBy: trackByFnc">
    <div class="faq-item stagger-in" (click)="n.expanded = !n.expanded" [ngClass]="{'is-active': n.expanded, 'theme-blue' : cueElement.color == 'blue'}">
      <div class="faq-item-header"><h5 class="faq-item-title">{{n.question}}</h5></div>
      <div class="faq-item-content" [ngClass]="{'is-active': n.expanded}"><p class="faq-item-answer">{{n.answer}}</p></div>
    </div>
  </div>
</div>
<div [innerHTML]="schema"></div>
